<template>
    <div>
        <limits-editable-table
            v-if="limitsRequired"
            v-model="form.limits.items"
            :total-cost="purchase.purchase_terms.contract_price"
            @validate="limitsValidate"
            :limit-year="purchase.purchase_terms.purchase_limit_year"
            :order-type="purchase.purchase_terms.order_type"
            purchase-type="fl44_unknown_volume"
            :purchase-id="purchase.id">
            <template #title>
                <h5 class="grey-color ml-1 mt-3 mb-1 main_text font-weight-bold">Измените лимиты</h5>
            </template>
        </limits-editable-table>
        <form-row-edit-supplier-accounting v-if="limitsRequired" v-model="form.supplier_accounting" @validate="supplierAccountingValidate">
            <template #title>
                <h5 class="ml-1 mt-3 mb-1 main_text font-weight-bold">Банковские реквизиты поставщика</h5>
            </template>
            <template #info>
                <div class="ml-1 fs-14">Укажите банковские реквизиты поставщика для заключения контракта, которые будут переданы в РИС после заключения.</div>
            </template>
        </form-row-edit-supplier-accounting>
        <form-row-edit-text label="Номер контракта в системе учета заказчика" title="Укажите номер контракта в случае если он отличается от номера контракта в ИС" v-model="form.customer_contract_number" :v="$v.form.customer_contract_number" compact />
        <b-row>
            <b-col>
                <fl44-unknown-volume-customer-sign-contract-button class="mt-3" :purchase="purchase" :is-available="!$v.$invalid" :form="form" @refresh="$emit('refresh')" />
                <fl44-unknown-volume-sign-decline-contract-button class="ml-2" :purchase-item="purchase" @refresh="$emit('refresh')" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { maxLength, requiredIf } from 'vuelidate/lib/validators';

import Config from '@/rearchitected/core/js/ddriven/application/config/Config';
import cloneDeep from 'lodash.clonedeep';
import Fl44UnknownVolumeCustomerSignContractButton from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-customer-sign-contract-button.vue';
import Fl44UnknownVolumeSignDeclineContractButton from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-sign-decline-contract-button.vue';

export default {
    name: 'private-fl44-unknown-volume-contract-sign-form-customer',
    components: { Fl44UnknownVolumeSignDeclineContractButton, Fl44UnknownVolumeCustomerSignContractButton },
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.form.limits.items = cloneDeep(this.purchase.contract.limits);
        Object.assign(this.form.supplier_accounting, this.purchase.contract.supplier_accounting);
    },
    data() {
        return {
            isDataSending: false,
            form: {
                limits: {
                    items: []
                },
                supplier_accounting: {
                    bank_type: 'bank',
                    bik: null,
                    bank_name: null,
                    bank_city: null,
                    ks: null,
                    rs: null,
                    ls: null,
                    fo_inn: null,
                    fo_name: null
                },
                customer_contract_number: null
            },
            isLimitsValid: false,
            isSupplierAccountingValid: false,
        };
    },
    validations() {
        return {
            form: {
                limits: {
                    isLimitsValid() {
                        return !this.limitsRequired || this.isLimitsValid;
                    },
                },
                supplier_accounting: {
                    required: requiredIf(() => this.limitsRequired),
                    isSupplierAccountingValid() {
                        return !this.limitsRequired || this.isSupplierAccountingValid;
                    }
                },
                customer_contract_number: {
                    maxlength: maxLength(255)
                }
            }
        };
    },
    methods: {
        limitsValidate(value) {
            this.isLimitsValid = !value;
        },
        supplierAccountingValidate(value) {
            this.isSupplierAccountingValid = !value;
        }
    },
    computed: {
        Config() {
            return Config;
        },
        limitsRequired() {
            return this.features.kbk_limits && !this.purchase.purchase_terms.without_limits;
        },
        features() {
            return Config.get('theme.features');
        }
    }
};
</script>
